import { Chip, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store'
import { AgenciesSelectors } from '../../../../../store/agencies'

interface TagProps {
  value: string | string[]
}

export const AgencyTag: FC<TagProps> = ({ value }) => {
  const theme = useTheme()

  const { backgroundColor, textColor, acronym } = useSelector((state: RootState) =>
    AgenciesSelectors.makeAgency(state, value)
  )

  return (
    <Chip
      variant="outlined"
      sx={{
        px: 1,
        my: '.2rem',
        height: '34px',
        backgroundColor,
        borderRadius: '24px',
        border: 'transparent',
        width: 'min-content',
        '& .MuiChip-label': {
          padding: 0,
        },
      }}
      label={
        <Typography
          variant="body1"
          sx={{
            color: textColor,
            fontSize: '12px',
          }}
        >
          {acronym}
        </Typography>
      }
    />
  )
}
